import React, {useEffect, useState} from 'react';
import './App.css';
import './Webflow.css';
import './Terms.css';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {createGlobalState} from "react-hooks-global-state";
import routes from "./routes";
import SettingsParentPage from "./views/apps/settings/SettingsParentPage";
import ParentPage from "./views/ParentPage";
import {QueryParamProvider} from 'use-query-params';
import {authenticationService} from "./services/authentication.service";
import {PublicParentPage} from "./views/apps/public/PublicParentPage";
import {userService} from "./services/user.service";
import {Skeleton} from "antd";
import CookieConsent, {Cookies, OPTIONS} from "react-cookie-consent";
import * as ReactGA from "react-ga";

export const SETTINGS_SIDER_DEFAULT_VALUES = {current: 'profile', collapsed: false};
export const DEFAULT_SIDER_DEFAULT_VALUES = {collapsed: false};
export const BACKUP_SIDER_DEFAULT_VALUES = {current: 'settings', collapsed: false, hideMenu: false};

const initialState = {
    user: undefined,
    mock: undefined,
    settingsSider: SETTINGS_SIDER_DEFAULT_VALUES,
    backupSider: BACKUP_SIDER_DEFAULT_VALUES,
    backup: undefined,
    defaultSider: DEFAULT_SIDER_DEFAULT_VALUES
};

export const {useGlobalState} = createGlobalState(initialState);

function RouteWithSubRoutes(route) {

    if (route.private && !authenticationService.isUserLoggedIn()) {
        return (<Redirect
            to={{
                pathname: "/login"
            }}
        />)
    } else if (route.template === 'connection') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (<route.component {...props} routes={route.routes}/>)}
            />
        );
    } else if (route.template === 'user') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <SettingsParentPage>
                        <route.component {...props} routes={route.routes}/>
                    </SettingsParentPage>)}
            />
        );
    } else if (route.template === 'ai') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <ParentPage user={route.user} className={""}>
                        <route.component {...props} routes={route.routes} user={route.user}/>
                    </ParentPage>)}
            />
        );

    } else if (route.template === 'chats') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <ParentPage user={route.user} className={""} showSidebar={false}>
                        <route.component {...props} routes={route.routes} user={route.user}/>
                    </ParentPage>)}
            />
        );


    } else if (route.template === 'default') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <ParentPage user={route.user}>
                        <route.component {...props} routes={route.routes} user={route.user}/>
                    </ParentPage>)}
            />
        );
    } else if (route.template === 'default-fullwidth') {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <ParentPage user={route.user} className={"default-fullwidth"}>
                        <route.component {...props} routes={route.routes} user={route.user}/>
                    </ParentPage>)}
            />
        );
    } else if (route.template === 'public' || route.private === false) {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props => (
                    <PublicParentPage>
                        <route.component {...props} routes={route.routes}/>
                    </PublicParentPage>)}
            />
        );
    }
}

const App = () => {

    const [user, setUser] = useState(undefined);

    const handleAcceptCookie = () => {
        if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
            ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
        }
    };

    const handleDeclineCookie = () => {
        Cookies.remove("_ga");
        Cookies.remove("_gat");
        Cookies.remove("_gid");
    };

    useEffect(() => {

        if (window.location.pathname !== "/login" && window.location.pathname !== "/confirm-email"
            && window.location.pathname !== "/invitation-email"
            && window.location.pathname !== "/reset-password"
            && window.location.pathname !== "/reset-password-request"
            && window.location.pathname !== "/oauth/microsoft/login"
            && window.location.pathname !== "/oauth/microsoft/callback"
            && window.location.pathname !== "/csv/samples"
            && window.location.pathname !== "/parquet/samples"
            && window.location.pathname !== "/csv/view"
            && window.location.pathname !== "/parquet/view"
            && window.location.pathname !== "/json/view"
            && window.location.pathname !== "/tsv/view"
            && window.location.pathname !== "/excel/view"
            && window.location.pathname !== "/terms-and-conditions"
            && window.location.pathname !== "/privacy-policy"
            && window.location.pathname !== "/cookies-policy"
            && window.location.pathname !== "/pricing"
            && window.location.pathname !== "/"
            && window.location.pathname !== "/connections/oauth/pipedrive/callback") {
            userService.me().then(response => {
                setUser(response.data);
            }).catch(error => {
                window.location = "/login";
            })
        }

    }, []);

    if (window.location.pathname !== "/login" && window.location.pathname !== "/confirm-email"
        && window.location.pathname !== "/invitation-email"
        && window.location.pathname !== "/reset-password"
        && window.location.pathname !== "/reset-password-request"
        && window.location.pathname !== "/oauth/microsoft/login"
        && window.location.pathname !== "/oauth/microsoft/callback"
        && window.location.pathname !== "/csv/samples"
        && window.location.pathname !== "/parquet/samples"
        && window.location.pathname !== "/csv/view"
        && window.location.pathname !== "/parquet/view"
        && window.location.pathname !== "/json/view"
        && window.location.pathname !== "/tsv/view"
        && window.location.pathname !== "/excel/view"
        && window.location.pathname !== "/terms-and-conditions"
        && window.location.pathname !== "/privacy-policy"
        && window.location.pathname !== "/cookies-policy"
        && window.location.pathname !== "/pricing"
        && window.location.pathname !== "/"
        && window.location.pathname !== "/connections/oauth/pipedrive/callback" && user === undefined) {
        return <Skeleton/>
    } else {
        return <BrowserRouter>
            <QueryParamProvider ReactRouterRoute={Route}>
                <div className="App">
                    <Switch>
                        {routes.map((route) => (
                            <RouteWithSubRoutes key={route.path} {...route} user={user}/>
                        ))}
                    </Switch>
                </div>
            </QueryParamProvider>
            <CookieConsent
                onAccept={handleAcceptCookie}
                onDecline={handleDeclineCookie}
                enableDeclineButton
                buttonText="Accept"
                declineButtonText="Decline"
                disableButtonStyles={true}
                buttonClasses="accept-button"
                declineButtonClasses="decline-button">
                By clicking “Accept”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage,
                and assist in our marketing efforts. View our Privacy Policy for more information.
            </CookieConsent>
        </BrowserRouter>
    }

};

export default App;